/* @ngInject */
function campaignInitialOnboardingService ($rootScope, $translate, $q, $state, UdsModalService) {
  const getOnboardingTwoFeatureDialogController = () => $q.when(import('../dialogs/onboarding-two-feature/onboarding-two-feature-dialog.controller'))

  const service = {
    openDialog,
    getOnboardingTwoFeatureDialogController,
    openDialogWithSocialMedia,
    openDialogWithAuditSocialMedia,
    onModalClose
  }
  return service

  function openDialog (onClose) {
    const promises = [
      $rootScope.getCompanyFeatures(),
      $rootScope.getEnableSocialMedia(true)
    ]

    $q.all(promises).then(([companyFeatures, isEnableSocialMedia]) => {
      if ($rootScope.isWorkflowPlan()) return

      if (isEnableSocialMedia) {
        openDialogWithAuditSocialMedia(onClose)
      } else {
        openDialogWithSocialMedia(onClose)
      }
    })
  }

  function openDialogWithSocialMedia (onClose) {
    getOnboardingTwoFeatureDialogController().then(({ OnboardingTwoFeatureDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: OnboardingTwoFeatureDialogController,
        modalName: 'onboardingTwoFeatureDialog',
        data: {
          title: $translate.instant('onboardingDialog.title'),
          features: [
            {
              title: $translate.instant('campaignsModule.title'),
              description: $translate.instant('onboardingDialog.campaignsDescription'),
              buttonText: $translate.instant('onboardingDialog.getToKnowCampaigns'),
              image: '/assets/img/onboarding/initial_campaigns.png',
              type: 'campaigns'
            },
            {
              title: $translate.instant('onboardingDialog.socialMediaIntegration'),
              description: $translate.instant('onboardingDialog.socialMediaDescription'),
              buttonText: $translate.instant('onboardingDialog.activateSocialMedia'),
              image: '/assets/img/onboarding/initial_social_media.png',
              type: 'social-media'
            }
          ]
        },
        onClose: service.onModalClose.bind(null, onClose)
      })
      modal.open()
    })
  }

  function openDialogWithAuditSocialMedia (onClose) {
    getOnboardingTwoFeatureDialogController().then(({ OnboardingTwoFeatureDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: OnboardingTwoFeatureDialogController,
        modalName: 'onboardingTwoFeatureDialog',
        data: {
          title: $translate.instant('onboardingDialog.title'),
          features: [
            {
              title: $translate.instant('campaignsModule.title'),
              description: $translate.instant('onboardingDialog.campaignsDescription'),
              buttonText: $translate.instant('onboardingDialog.getToKnowCampaigns'),
              image: '/assets/img/onboarding/initial_campaigns.png',
              type: 'campaigns'
            },
            {
              title: $translate.instant('onboardingDialog.socialMediaAudit'),
              description: $translate.instant('onboardingDialog.auditSocialMediaDescription'),
              buttonText: $translate.instant('onboardingDialog.accessAuditSocialMedia'),
              image: '/assets/img/onboarding/initial_audit_social_media.png',
              type: 'audit-social-media'
            }
          ]
        },
        onClose: service.onModalClose.bind(null, onClose)
      })
      modal.open()
    })
  }

  function onModalClose (onClose, type) {
    onClose()

    if (type === 'campaigns') {
      $state.go('campaigns')
    } else if (type === 'social-media') {
      $state.go('arts.templates')
    } else if (type === 'audit-social-media') {
      $state.go('audit.socialMedia')
    }
  }
}

export { campaignInitialOnboardingService }
